/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { App } from '../../models/app';

export interface AppControllerRemove$Params {
  appId: string;
}

export function appControllerRemove(http: HttpClient, rootUrl: string, params: AppControllerRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<App>> {
  const rb = new RequestBuilder(rootUrl, appControllerRemove.PATH, 'delete');
  if (params) {
    rb.path('appId', params.appId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<App>;
    })
  );
}

appControllerRemove.PATH = '/app/{appId}';
